import { Box, DialogContent } from "@mui/material";
import { sanitizeHtml } from "../utils/sanitize-html";

const ViewRichTextEditor = ({
  value,
  minHeight = 200,
  maxHeight = 500,
}: {
  value: string;
  minHeight?: number;
  maxHeight?: number;
}) => {
  return (
    <DialogContent>
      <Box
        sx={{
          minHeight: `${minHeight}px`,
          maxHeight: `${maxHeight}px`,
          overflow: "auto",
        }}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(value) }}
      />
    </DialogContent>
  );
};

export default ViewRichTextEditor;
